import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const config = {
  
        apiKey: "AIzaSyDwSZkmPZkQZpMsMVs0hpJq9zR0o2yu-MU",
        authDomain: "evaluaciones-998d7.firebaseapp.com",
        projectId: "evaluaciones-998d7",
        storageBucket: "evaluaciones-998d7.appspot.com",
        messagingSenderId: "706510002280",
        appId: "1:706510002280:web:b670716f6bf646376ec3dd",
        measurementId: "G-4PKZRLMTGT"
};

firebase.initializeApp(config);
export const db = firebase.firestore();